<template>
  <div
    class="the-navbar__user-meta flex items-center"
    v-if="customer.display_name"
  >
    <div class="text-right leading-tight sm:block">
      <p class="font-semibold">{{ customer.display_name }}</p>
    </div>

    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
      <div class="con-img ml-3">
        <img
          v-if="avatar"
          key="onlineImg"
          :src="avatar"
          alt="user-img"
          width="40"
          height="40"
          class="rounded-full shadow-md cursor-pointer block"
        />
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 9rem">
          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="logout"
          >
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">{{ $t("logout") }}</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {};
  },
  computed: {
    ...mapState(["customer"]),
    avatar() {
      return require("@/assets/images/portrait/small/noavatar.svg");
    }
  },
  methods: {
    ...mapActions(["signOutOidc"]),
    logout() {
      // This is just for demo Purpose. If user clicks on logout -> redirect
      this.signOutOidc();
    }
  }
};
</script>
